import { fromJS } from 'immutable'
export default fromJS({
  contactPhoneNumber: {
    private: '0418756000',
    corporate: '0418756000'
  },
  tve: {
    title: 'Jetzt Termin vereinbaren'
  },
  login: {
    title: 'Sind Sie bereits Kunde bei der UKB?'
  },
  customerType: {
    title: 'Sind Sie Privat- oder Firmenkunde?'
  },
  subject: {
    title: 'Zu welchen Themen wünschen Sie eine Beratung?',
    commentPlaceholder: 'Ihr Kommentar...'
  },
  branch: {
    title: 'Wie möchten Sie beraten werden?'
  },
  appointment: {
    title: 'Wählen Sie Ihren gewünschten Termin aus:'
  },
  userForm: {
    title: 'Ihre Kontaktangaben:',
    existingCustomer: 'Sie sind bereits UKB-Kunde, dennoch benötigen wir Ihre Angaben zur Bestätigung der Identität.'
  },
  confirmation: {
    title: 'Ihr Termin',
    when: 'Wann',
    whenTime: '${time} - ${until} Uhr',
    where: 'Wo',
    showOnMap: 'Auf Karte anzeigen',
    phone: 'Bequem von zuhause - Der Kundenberater / die Kundenberaterin wird Sie zum vereinbarten Termin anrufen.',
    personal: 'Bei Ihnen zuhause ',
    corporate: {
      personal: 'Bei Ihnen im Unternehmen'
    },
    advisorTitle: {
      male: 'Ihr Kundenberater',
      female: 'Ihre Kundenberaterin'
    },
    topics: 'Themen',
    checklist: 'Checkliste',
    urlChecklist: '«Checkliste»',
    checklistInfo: 'Bitte nehmen Sie folgende Dokumente mit zum Termin.',
    uploadDocuments: 'Wenn Sie bereits die Dokumente in digitaler Form hochladen möchten, können Sie dies hier tun:',
    financeUploadInfo:
      'Da Sie das Thema Finanzieren gewählt haben, bitten wir Sie, Ihre Unterlagen zwei Tage im Voraus hochzuladen.',
    changeReverse: 'Änderungen zum Termin'
  },
  update: {
    title: 'Termin verschieben'
  },
  cancelled: {
    title: 'Termin wurde storniert',
    content:
      'Besten Dank für Ihr Interesse an einem Beratungstermin. Die Stornierung des gebuchten Termins haben wir zur Kenntnis genommen und den Eintrag bei uns gelöscht. Wir freuen uns, Sie zu einem späteren Zeitpunkt zu einem Termin zu begrüssen.'
  },
  otp: {
    title: 'Log-in',
    resend: 'Bitte Code erneut zusenden',
    verify: 'Log-in',
    disclaimer:
      'Bitte fordern Sie per SMS einen sechsstelligen Code an, damit wir Ihre Identität sicherstellen können.',
    weHaveSent:
      'Wir haben Ihnen einen Code per SMS an Ihre Mobiltelefonnummer <span className="atp-bold atp-no-break">${number}</span> gesendet.',
    send: 'Code anfordern',
    pleaseEnterTheCode: 'Bitte geben Sie den Code zur Bestätigung ein.'
  },
  components: {
    advisorInfo: {
      title: 'Ihr Kundenberater'
    },
    openingTimes: {
      openFromTo: '${start} - ${end} Uhr',
      weekdays: 'Montag – Freitag',
      weekends: 'Samstag'
    },
    unattendedBranch: {
      contact: 'Kontaktieren Sie unser Kundencenter:',
      text:
        'Vom ersten Bankkonto über die Finanzierung des Eigenheims oder der Firma bis zur Geldanlage: Die UKB begleitet Sie in die Zukunft. Nehmen Sie einfach Kontakt mit uns auf und wir beraten Sie gerne.'
    },
    appointmentSummary: {
      whenTime: '${time} - ${until} Uhr',
      atYourHome: 'Das Gespräch ist bei Ihnen Zuhause.',
      atYourCompany: 'Das Gespräch ist in Ihrem Unternehmen.',
      phone: 'Das Gespräch ist via Telefon.',
      anyQuestions: 'Fragen zum Termin?',
      yourSelection: 'Ihre Auswahl',
      tel: 'Tel. ${number}',
      where: 'Wo findet die Beratung statt?'
    },
    appointmentGrid: {
      availableEvents: 'Diese Woche sind keine Termine verfügbar.',
      checkNextWeek: 'Bitte prüfen Sie die nächste Woche oder nehmen Sie mit uns telefonisch Kontakt auf.',
      empty: 'Keine verfügbaren Termine',
      lastWeek: 'Vorherige Termine anzeigen',
      nextWeek: 'Weitere Termine anzeigen',
      requestError: {
        phone: 'Oder vereinbaren Sie Ihren Termin telefonisch:',
        retry: 'Erneut versuchen',
        title: 'Leider können keine verfügbaren Termine gefunden werden.'
      },
      whichBranch: 'An welchem Standort wünschen Sie die Beratung?'
    },
    navigation: {
      steps: {
        branch: {
          bank: 'Ich komme in die Geschäftsstelle in ${city}.',
          personal: 'Das Gespräch ist bei Ihnen Zuhause.',
          corporate: {
            personal: 'Das Gespräch ist in Ihrem Unternehmen.'
          },
          phone: 'Das Gespräch ist via Telefon.',
          advisor: { bank: 'Mit ${name} am Standort' }
        },
        customerType: {
          corporate: 'Ich bin Firmenkunde.',
          private: 'Ich bin Privatkunde.'
        },
        login: {
          new: 'Ich bin noch kein Kunde.',
          existing: 'Ich bin schon Kunde.'
        },
        appointment: 'Mein Terminwunsch: ${appointment}.',
        subject: 'Meine Themenwahl: ${subject}.'
      },
      and: 'und',
      yourSelection: 'Ihre Auswahl'
    },
    yourSelection: 'Ihre Auswahl',
    noEarlierAppointments: {
      text:
        'Leider können keine verfügbaren Termine gefunden werden. Bitte kontaktieren Sie uns telefonisch, um einen passenden Termin zu finden:',
      tel: 'Tel. ${number}'
    },
    wrongTimeWrongPlace: {
      title: 'Sie finden keinen passenden Termin?',
      text: 'Vielleicht finden wir am Telefon eine Lösung:'
    }
  },
  attributes: {
    labels: {
      // login
      loginType: 'Bitte geben Sie Ihre IBAN- oder E-Banking Konto-Nr. ein.',

      // subject
      subject: 'Sie können ein oder mehrere Themen auswählen.',
      comment: 'Beschreiben Sie uns Ihr konkretes Anliegen (optional).',

      // userForm
      gender: 'Anrede',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Mobile',
      street: 'Adresse',
      zip: 'PLZ',
      city: 'Ort',
      birthDate: 'Geburtsdatum',
      termsAndConditions:
        'Ja ich akzeptiere die <a href="https://www.ukb.ch/e-service/online-dokumente/nutzungsbestimmungen/" className="atp-bold">Nutzungsbestimmungen</a>',

      company: 'Firmenname',

      // confirmation
      cancellationReason: 'Absagegrund:',
      cancellationComment: 'Kommentar (Optional)',

      // otp
      pin: 'Bestätigungscode'
    },
    errors: {
      event: 'Bitte wählen Sie einen Termin aus.',
      medium: 'Bitte wählen Sie aus, wie Sie beraten werden möchten.',
      branch: 'Wählen Sie eine Geschäftsstelle aus.',
      contractNumberOrIbanRequired: 'Bitte geben Sie Ihre IBAN- oder Konto-Nr. ein'
    }
  },
  options: {
    existingClient: {
      true: 'Ja',
      false: 'Nein, noch nicht.'
    },
    customerType: {
      private: 'Privatkunde',
      corporate: 'Firmenkunde'
    },
    gender: {
      male: 'Herr',
      female: 'Frau'
    },
    cancelReasons: {
      no_need: 'Informationen anderweitig beschafft',
      illness: 'Krankheit / Unfall',
      personal: 'Persönlicher Grund',
      other: 'Anderer Absagegrund'
    },
    loginType: { iban: 'IBAN', contractNumber: 'Konto-Nr.' },
    mediums: {
      bank: 'Persönlich in unserer Geschäftsstelle',
      personal: 'Persönlich bei Ihnen Zuhause',
      corporate: {
        personal: 'Persönliche Beratung in Ihrem Unternehmen'
      },
      phone: 'Telefonisch'
    }
  },
  buttons: {
    next: 'Weiter »',
    previous: '« Zurück',
    cancel: 'Abbrechen',
    reverse: 'Stornieren',
    move: 'Verschieben',
    bookNow: 'Jetzt buchen',
    moveNow: 'Jetzt verschieben'
  },
  contentTypes: {
    audio: 'Audio',
    document: 'Dokument',
    image: 'Bild',
    pdf: 'PDF'
  },
  error: {
    network: 'Es konnte keine Verbindung zum Server aufgebaut werden. Versuchen sie es bitte erneut.'
  }
})
